
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnerstack-alternative",
      function () {
        return require("private-next-pages/partnerstack-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnerstack-alternative"])
      });
    }
  